document.addEventListener("alpine:init", () => {
    Alpine.data("scrollSwitcher", () => ({
        active: null,
        items: null,
        i: 0,
        positionTop: 0,
        lastScrollTop: 0,
        init() {
            this.positionTop = pegasus.getElemOffset(this.$el);

            pegasus.onResizeFinished(() => {
                setTimeout(() => {
                    this.checkPosition();
                }, 200);
            }, true);
        },
        checkPosition(onLoad = false) {
            const contentRows = this.$el.querySelectorAll(
                ".Scroll__Switcher__Trigger__Item"
            );

            const windowOffset = window.outerHeight / 2;
            const windowCenter = window.scrollY + window.outerHeight / 2;
            const overlapZone = window.outerHeight * 0.25; // 10% of viewport height
            const overlapHalf = overlapZone / 2;

            contentRows.forEach((row) => {
                if (
                    typeof row.id === "undefined" ||
                    row.id === null ||
                    row.id === ""
                ) {
                    return false;
                }
                const rowTop = pegasus.getElemOffset(row).top,
                    rowBottom = pegasus.getElemOffset(row).bottom,
                    rowCenter = rowTop + (row.offsetHeight / 2);

                let st = window.scrollY;

                if (onLoad) {
                    if (
                        window.scrollY + windowOffset >= rowTop &&
                        window.scrollY + windowOffset <= rowBottom
                    ) {
                        this.active = row.id;
                        this.$dispatch("pegasus-ss-item-selected", {
                            id: row.id,
                        });
                    }
                }

                if (st >= this.lastScrollTop) {
                    //Scroll Down
                    if (
                        rowCenter <= windowCenter + overlapHalf &&
                        rowBottom >= windowCenter - overlapHalf
                    ) {
                        this.active = row.id;
                        this.$dispatch("pegasus-ss-item-selected", {
                            id: row.id,
                        });
                    }
                } else {
                    //Scroll Up
                    if (
                        rowTop <= windowCenter + overlapHalf &&
                        rowCenter >= windowCenter - overlapHalf
                    ) {
                        this.active = row.id;
                        this.$dispatch("pegasus-ss-item-selected", {
                            id: row.id,
                        });
                    }
                }

                this.lastScrollTop = st;
            });

            if (window.scrollY <= this.positionTop.top) {
                const allItems = this.$el.querySelectorAll(
                    ".Scroll__Switcher__Trigger__Item"
                );

                this.active = allItems[0].id;
                this.$dispatch("pegasus-ss-item-selected", {
                    id: allItems[0].id,
                });
            }
        },
    }));
});